<template>
	<div class="chat-tool-indicator">
		<div class="chat-tool-indicator-icon" :style="iconStyle">
			<v-icon size="14" :color="$corTextoPrimary">mdi-database-search-outline</v-icon>
		</div>
		<div class="chat-tool-indicator-text">
			<span>{{ label }}</span>
			<span class="chat-tool-indicator-dots">
				<i></i><i></i><i></i>
			</span>
		</div>
	</div>
</template>

<script>
const FRIENDLY_LABELS = {
	consultar_manuais: 'Consultando manuais',
	consultar_conteudo_manual: 'Consultando seu manual',
	meus_chamados: 'Consultando seus chamados',
	meus_documentos: 'Consultando seus documentos',
	registrar_pergunta_nao_atendida: 'Registrando sua pergunta',
};

export default {
	name: 'ChatToolIndicator',

	props: {
		toolName: {
			type: String,
			required: true,
		},
	},

	computed: {
		label() {
			return FRIENDLY_LABELS[this.toolName] || 'Analisando seus dados';
		},
		iconStyle() {
			return { background: this.$vuetify?.theme?.themes?.light?.primary };
		},
	},
};
</script>

<style scoped>
.chat-tool-indicator {
	display: flex;
	align-items: center;
	gap: 10px;
	margin: 8px 0 8px 40px;
	padding: 8px 12px;
	background: rgba(255, 255, 255, 0.7);
	border: 1px solid rgba(148, 163, 184, 0.3);
	border-radius: 14px;
	width: fit-content;
	max-width: 78%;
	font-size: 13px;
	animation: bubble-in 220ms ease both;
}

.chat-tool-indicator-icon {
	width: 26px;
	height: 26px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.chat-tool-indicator-text {
	display: flex;
	align-items: center;
	gap: 6px;
	color: #475569;
	font-weight: 600;
}

.chat-tool-indicator-dots {
	display: inline-flex;
	gap: 3px;
}

.chat-tool-indicator-dots i {
	width: 4px;
	height: 4px;
	background: #94a3b8;
	border-radius: 50%;
	animation: dot-pulse 1.2s infinite ease-in-out;
}

.chat-tool-indicator-dots i:nth-child(2) { animation-delay: 0.15s; }
.chat-tool-indicator-dots i:nth-child(3) { animation-delay: 0.3s; }

@keyframes dot-pulse {
	0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
	30% { transform: translateY(-3px); opacity: 1; }
}

@keyframes bubble-in {
	from { opacity: 0; transform: translateY(4px); }
	to { opacity: 1; transform: translateY(0); }
}
</style>
